import { Component, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { FrontendFieldDefinition } from 'src/modules/sm-base/models/frontend-field-definition.model';
import { FrontendFieldType } from 'src/modules/sm-base/models/frontend-field-type.enum';
import { FrontendFormDefinition } from 'src/modules/sm-base/models/frontend-form-definition.model';
import { EnaioLearnService } from '../../services/enaio-learn.service';
import { LearningContentType } from '../../shared/learning-content-type.entity';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';

@Component({
    selector: 'app-edit-learning-content-type',
    templateUrl: './edit-learning-content-type.component.html',
    styleUrls: ['./edit-learning-content-type.component.scss']
})
export class EditLearningContentTypeComponent extends ComponentView {

    service = inject(EnaioLearnService);

    neededParams: ObjectOfSimpleDataTypes = { id: "number" };
    id: number;

    item: LearningContentType;
    form: FrontendFormDefinition;

    async initParams(): Promise<boolean> {
        this.form = this.app.tForm("lea.learningContentType", new FrontendFormDefinition([
            new FrontendFieldDefinition("name", null, FrontendFieldType.text, {mandatory: true})
        ]));
        this.item = await this.service.adminInitEdit(LearningContentType, this.id, this.form, "lea.learningContentType", "learning-content-types", "learning-content-type", "api/lrn/learningcontenttype");
        return true;
    }

    save(): void {
        this.service.adminUpdate(this.form, LearningContentType, this.item, "api/lrn/learningcontenttype");
    }
}
